import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const DailyRemindersPage = lazy(() =>
  import("./pages/DailyRemindersPage").then((m) => ({ default: m.DailyRemindersPage }))
);

export const RemindersRoutes: RouteObject = {
  path: "/reminders",
  children: [
    {
      index: true,
      element: <DailyRemindersPage />,
    },
  ],
};
